import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { ExclamationTriangleFill } from 'react-bootstrap-icons';
import './DeleteConfirmationModal.css';

interface DeleteConfirmationModalProps {
  show: boolean;
  onHide: () => void;
  onConfirm: () => void;
  itemType: 'Project' | 'Conversation' | 'Artifact' | 'File';
  itemName?: string;
  artifactCount?: number;
}

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
  show,
  onHide,
  onConfirm,
  itemType,
  itemName,
  artifactCount = 0
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="delete-confirmation-modal"
    >
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="d-flex align-items-center gap-2">
          <ExclamationTriangleFill size={24} color="#ff9800" />
          <span>Delete {itemType}</span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="pt-3">
        <p className="mb-0">
          {itemType === 'File' ? (
            <>
              Are you sure you want to delete{' '}
              {itemName ? <strong>{itemName}</strong> : 'this file'}? Any signals extracted from
              this file will also be removed.
            </>
          ) : (
            <>
              Are you sure you would like to delete this {itemType.toLowerCase()}? You will also be
              deleting {artifactCount} artifacts associate with this {itemType.toLowerCase()}.
            </>
          )}
        </p>
      </Modal.Body>
      <Modal.Footer className="border-0 pt-0">
        <Button
          variant="link"
          onClick={onHide}
          className="text-decoration-none text-dark cancel-btn"
        >
          CANCEL
        </Button>
        <Button
          variant="warning"
          onClick={onConfirm}
          className="confirm-btn"
        >
          Confirm
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteConfirmationModal;
